
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Search, UserPlus } from "lucide-react";
import { EnhancedUser } from "./EnhancedUsersSection";

interface UserFiltersProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  managementTypeFilter: string;
  onManagementTypeChange: (type: string) => void;
  users: EnhancedUser[];
  shouldShowAddButton?: boolean;
  onAddUser?: () => void;
  isUserSideViewOpen?: boolean;
}

export const UserFilters = ({
  searchTerm,
  onSearchChange,
  managementTypeFilter,
  onManagementTypeChange,
  users,
  shouldShowAddButton = false,
  onAddUser,
  isUserSideViewOpen = false
}: UserFiltersProps) => {
  return (
    <div className="flex items-center justify-between space-x-4 flex-wrap gap-2">
      <div className="flex items-center space-x-4 flex-wrap gap-2 flex-1">
        <div className="relative flex-1 max-w-sm">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search users..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-8 focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-black/20"
          />
        </div>

        <Select value={managementTypeFilter} onValueChange={onManagementTypeChange}>
          <SelectTrigger className="w-48">
            <SelectValue placeholder="Management Type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Types</SelectItem>
            <SelectItem value="parent">Parent</SelectItem>
            <SelectItem value="child">Child</SelectItem>
            <SelectItem value="support">Support</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      {shouldShowAddButton && onAddUser && !isUserSideViewOpen && (
        <Button onClick={onAddUser} size="sm" className="flex items-center gap-2">
          <UserPlus className="w-4 h-4" />
          Add User
        </Button>
      )}
    </div>
  );
};
